import type { ReactNode } from "react"
import { Shuffle } from "react-feather"
import { Button } from "@/components/ui/button"
import { Card } from "@/components/ui/card"

interface InfoItem {
  label: string
  value: string | ReactNode
}

interface TicketInfoSectionProps {
  title: string
  items: InfoItem[]
  onAction?: () => void
  actionLabel?: string
}

export function TicketInfoSection({ title, items, onAction, actionLabel }: TicketInfoSectionProps) {
  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-base font-semibold text-slate-900">{title}</h3>
        {onAction && actionLabel && (
          <Button variant="outline" size="sm" onClick={onAction} className="gap-2">
            <Shuffle className="h-3.5 w-3.5" />
            {actionLabel}
          </Button>
        )}
      </div>
      <Card className="divide-y divide-slate-300 p-3.5">
        {items.map((item) => (
          <div key={`${item.label}`} className="flex items-center py-2.5">
            <span className="text-xs font-semibold text-slate-400 w-24">{item.label}</span>
            <div className="flex-1 text-sm font-semibold text-slate-600">{item.value}</div>
          </div>
        ))}
      </Card>
    </div>
  )
}
